import React, { useState } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import TeamSection from './TeamSection';
import EventsSection from './EventsSection';
import ContactSection from './ContactSection';
import FooterSection from './FooterSection';
import { submitContactForm } from '../../services/firebaseService';

const LandingPage: React.FC = () => {
  // Contact form state (move here for prop drilling)
  const [contact, setContact] = useState({ name: '', email: '', message: '' });
  const [contactError, setContactError] = useState('');
  const [contactSuccess, setContactSuccess] = useState(false);

  const handleContactChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setContact({ ...contact, [e.target.name]: e.target.value });
    setContactError('');
    setContactSuccess(false);
  };

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!contact.name.trim() || !contact.email.trim() || !contact.message.trim()) {
      setContactError('Please fill in all fields.');
      return;
    }
    
    try {
      setContactError('');
      await submitContactForm(contact);
      setContactSuccess(true);
      setContact({ name: '', email: '', message: '' });
    } catch (error) {
      setContactError('Failed to send message. Please try again.');
      console.error('Contact form submission error:', error);
    }
  };

  return (
    <ParallaxProvider>
      <HeroSection />
      <AboutSection />
      <EventsSection />
      <TeamSection />
      
      <ContactSection
        contact={contact}
        contactError={contactError}
        contactSuccess={contactSuccess}
        handleContactChange={handleContactChange}
        handleContactSubmit={handleContactSubmit}
      />
      <FooterSection />
    </ParallaxProvider>
  );
};

export default LandingPage; 